export const ContactTranslations = {
    en: {
        contact: {
            title: 'Contact Us',
            address: 'Address',
            email: 'Email',
            phone: 'Phone',
            akurdiOffice: {
              title: 'Location',
              address: { 
                line1: ' Director, Town Planning, Maharashtra State',
                line2: ' Central Building, ',
                line3: ' Ground floor, Pune 411001'
              }
            },
            adminOffice: {
              title: 'Head Office',   
              address: {
                line1: 'Assistant Director of Town planning',
                line2: 'near school no.1 Madan bhau  ',
                line3: 'Patil sankul imarat sangli'
              }
            },
            otherDetails: {
              title: 'Other Details',
              telephone: 'Telephone Directory',
              telephoneText: 'Available on Request',
              hours: 'Office Hours',
              hoursText: '9:45 AM to 6:15 PM',
              weeklyOff: 'Weekly Off',
              weeklyOffText: 'Saturday and Sunday',
              publicHolidays: 'List of Public Holidays',
              publicHolidaysDownload: 'Download'
              
            },
            directory: {
              title: 'Directory of Officials',
              srNo: 'Sr. No.',
              officerName: 'Officer Name',
              designation: 'Designation',
              department: 'Department',
              phone: 'Phone No.',
              email: 'Email ID',
              divison: 'Divison',
              officers: {
                officer1: {
                  name: 'Dr. Pratibha Bhadane',
                  designation: 'Metropolitan Commissioner CEO',
                  department: 'Director, Town Planning, Maharashtra State, Pune',
                  division: 'Head Office',
                  phone: '020-26122076',
                  email: 'dirtpvd.pune@maharashtra.gov.in'
                },
                officer2: {
                  name: 'Mr. Owais Ejaz Momin',
                  designation: 'Personal Assistant (PA) of Metropolitan Commissioner',
                  department: 'Joint Director, Town Planning, Amaravati',
                  division: 'Amaravati',
                  phone: '0721-2570 226',
                  email: 'jdtpdn_amravati@rediffmail.com'
                },
                officer3: {
                  name: 'Mr. Navnath Bhausaheb Nagargoje',
                  designation: 'Additional Metropolitan Commissioner',
                  department: 'Joint Director, Town Planning, Chatrapati Sambhaji Nagar Division',
                  division: 'Chatrapati Sambhaji Nagar',
                  phone: '0240-2334354',
                  email: 'jdtpdn_abad@rediffmail.com'
                },
                officer4: {
                  name: 'Mr. Shrikant Marutirao Deshmukh',
                  designation: 'Financial Controller',
                  department: 'Joint Director, Town Planning, Kokan Division',
                  division: 'Kokan',
                  phone: '022-2757 1569 / 022-2757 2271',
                  email: 'jdtpdn_kokan@rediffmaill.com'
                },
                officer5: {
                  name: 'Mr. Vijay Babarav Shende',
                  designation: 'Joint Commissioner',
                  department: 'Joint Director, Town Planning, Nagpur Division',
                  division: 'Nagpur',
                  phone: '0712 – 256 5020',
                  email: 'jdtpdn_nagpur@rediffmail.com'
                },
                officer6: {
                  name: 'Mr. Akash Tikaram Bagul',
                  designation: 'Joint Commissioner',
                  department: 'Joint Director, Town Planning, Nashik Division',
                  division: 'Nashik',
                  phone: '0253-246 2305',
                  email: 'jdtpdn_nashik@rediffmail.com'
                },
                officer7: {
                  name: 'Mr. Rajendra Mahadev Pawar',
                  designation: 'Metropolitan Planner',
                  department: 'Joint Director, Town Planning, Pune Division',
                  division: 'Pune',
                  phone: '020 - 2612 5922',
                  email: 'jdtpdn_pune@rediffmail.com'
                }
                
                
                
              }
            }
          },


    },
    mr: {
        contact: {
            title: 'संपर्क करा',
            address: 'पत्ता',
            email: 'ईमेल',
            phone: 'दूरध्वनी क्रमांक',
            akurdiOffice: {
              title: 'स्थान',
              address: {
                line1: 'संचालक, नगर रचना, महाराष्ट्र राज्य',
                line2: 'सेंट्रल बिल्डिंग,',
                line3: 'तळमजला, पुणे ४११००१'
              }
            },
            adminOffice: {
              title: 'मुख्य कार्यालय',
              address: {
                line1: 'सेंट्रल बिल्डिंग,',
                line2: 'तळमजला,',
                line3: 'पुणे ४११००१'
              }
            },
            otherDetails: {
              title: 'इतर तपशील',
              telephone: 'टेलिफोन डिरेक्टरी',
              telephoneText: 'विनंतीवर उपलब्ध',
              hours: 'कार्यालयीन वेळ',
              hoursText: 'सकाळी 9:45 ते संध्याकाळी 6:15',
              weeklyOff: 'साप्ताहिक सुट्टी',
              weeklyOffText: 'शनिवार व रविवार',
              publicHolidays: 'सार्वजनिक सुट्टी यादी',
              publicHolidaysDownload: 'डाऊनलोड'
            },
            directory: {
              title: 'अधिकाऱ्यांची यादी',
              srNo: 'क्र.',
              officerName: 'अधिकाऱ्याचे नाव',
              designation: 'पदनाम',
              department: 'विभाग',
              phone: 'दूरध्वनी क्रमांक',
              email: 'ईमेल आयडी',
              divison: 'विभाग',
              officers: {
                officer1: {
                  name: 'डॉ. प्रतिभा भदाणे',
                  designation: 'महानगर आयुक्त सीईओ',
                  department: 'संचालक, नगर रचना, महाराष्ट्र राज्य, पुणे',
                  division: 'मुख्य कार्यालय',
                  phone: '020-26122076',
                  email: 'dirtpvd.pune@maharashtra.gov.in'
                },
                officer2: {
                  name: 'श्री.ओवैस एजाज मोमीन',
                  designation: 'महानगर आयुक्ताचे वैयक्तिक सहाय्यक (PA)',
                  department: 'सहसंचालक, नगर रचना, अमरावती विभाग',
                  division: 'अमरावती',
                  phone: '0721-2570 226',
                  email: 'jdtpdn_amravati@rediffmail.com'
                },
                officer3: {
                  name: 'श्री.नवनाथ भाऊसाहेब नागरगोजे',
                  designation: 'अतिरिक्त महानगर आयुक्त',
                  department: 'सहसंचालक, नगर रचना, छत्रपती संभाजी नगर विभाग',
                  division: 'छत्रपती संभाजी नगर',
                  phone: '0240-2334354',
                  email: 'jdtpdn_abad@rediffmail.com'
                },
                officer4: {
                  name: 'श्री.श्रीकांत मारुतीराव देशमुख',
                  designation: 'वित्त नियंत्रक',
                  department: 'सहसंचालक, नगर रचना, कोकण विभाग',
                  division: 'कोकण',
                  phone: '022-2757 1569 / 022-2757 2271',
                  email: 'jdtpdn_kokan@rediffmaill.com'
                },
                officer5: {
                  name: 'श्री.विजय बाबाराव शेंडे',
                  designation: 'संयुक्त आयुक्त',
                  department: 'सहसंचालक, नगर रचना, नागपूर विभाग',
                  division: 'नागपूर',
                  phone: '0712 – 256 5020',
                  email: 'jdtpdn_nagpur@rediffmail.com'
                },
                officer6: {
                  name: 'श्री.आकाश टिकाराम बागुल',
                  designation: 'संयुक्त आयुक्त',
                  department: 'सहसंचालक, नगर रचना, नाशिक विभाग',
                  division: 'नाशिक',
                  phone: '0253-246 2305',
                  email: 'jdtpdn_nashik@rediffmail.com'
                },
                officer7: {
                  name: 'श्री.राजेंद्र महादेव पवार',
                  designation: 'महानगर नियोजक',
                  department: 'सहसंचालक, नगर रचना, पुणे विभाग',
                  division: 'पुणे',
                  phone: '020 - 2612 5922',
                  email: 'jdtpdn_pune@rediffmail.com'
                }
                
                
              }
            }
          },

    }
};
